export default __webpack_public_path__ + "images/bullet2-Pw2za.png";